import { Avatar } from '@mui/material'

type EntityIconProps = {
  src?: string
  size: number
  variant?: 'circular' | 'square'
  className?: string
}

export const EntityIcon = ({
  src,
  size,
  variant = 'circular',
  className,
}: EntityIconProps) => (
  <Avatar
    src={src}
    variant={variant}
    className={className}
    sx={{ width: size, height: size, margin: 0, flexShrink: 0 }}
  />
)
